import { debounce } from "lodash-es";
import { useEffect, useMemo, useState } from "react";

export function useDebounce<T>(value: T, debounceTime: number = 1000): T {
  const [debouncedValue, setValue] = useState<T>(value);

  const debouncedSetValue = useMemo(() => {
    return debounce((value) => {
      setValue(value);
    }, debounceTime);
  }, []);

  useEffect(() => {
    debouncedSetValue(value);
    return () => {
      debouncedSetValue.cancel();
    };
  }, [value]);

  return debouncedValue;
}
